import React from 'react';

import Authentication from 'components/Authentication';
import ExternalScripts from 'components/ExternalScripts';
import RedirectAccountType from 'components/RedirectAccountType';
import { MY_APPLICATION_LISTING } from 'constants/routes';
import AppLayout from 'layout/App';
import RevolvingTransactionDetailScreen from 'screens/RevolvingTransactionDetailScreen';
import DaktelaCustomerChat from 'sections/DaktelaCustomerChat';

function Page(props) {
	return (
		<Authentication>
			<AppLayout>
				<RedirectAccountType miniPackageTo={MY_APPLICATION_LISTING}>
					<ExternalScripts secured />
					<DaktelaCustomerChat pageType="self-care" />

					<RevolvingTransactionDetailScreen {...props} />
				</RedirectAccountType>
			</AppLayout>
		</Authentication>
	);
}

export default Page;
